const chatMessage = {
  title: 'Click.AI',
  helpPrompt: {
    title: 'Como posso te ajudar hoje?',
    firstSteps: 'Guia de primeiros passos',
    model: 'Como criar um modelo?',
  },
  footer: {
    input: {
      placeholder: 'Fale com o Click.AI',
    },
    help: {
      text: 'Ainda tem dúvidas? Acesse nossa',
      link: 'Central de Ajuda',
    },
  },
};

export default chatMessage;
